module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-option"
  }, [_c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("CALIFICANOS")]), _vm._v(" "), _c('el-rate', {
    attrs: {
      "colors": _vm.colors,
      "void-color": "#2c404a"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('el-form', {
    staticClass: "d-flex wrap",
    attrs: {
      "model": _vm.model,
      "rules": _vm.responsibleRules
    }
  }, [_c('el-form-item', {
    staticClass: "flex-95 mx-1",
    attrs: {
      "prop": "description"
    }
  }, [_c('el-input', {
    staticClass: "qtc-input",
    attrs: {
      "type": "textarea",
      "rows": "4",
      "placeholder": "Describe tu experiencia"
    },
    model: {
      value: (_vm.model.description),
      callback: function($$v) {
        _vm.$set(_vm.model, "description", $$v)
      },
      expression: "model.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center space-evenly w-100"
  }, [_c('button', {
    staticClass: "cancel-button",
    style: (("background-color:" + (_vm.globalColors.hover))),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelRating
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn-send-opinion",
    class: [{
      'disable-btn': _vm.disabledBtn
    } ],
    style: (("background-color:" + (_vm.globalColors.primary))),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendOpinion
    }
  }, [_vm._v("Enviar")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a8c582","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/formOpinion.vue
// module id = 662
// module chunks = 1 48